import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {Link} from 'react-router-dom';
import {Pagination, Loader} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';
import {PANEL_STATUS_CHANGE_DISPLAY} from 'app-ui-componentlibrary/dist/common/constants';
import {compileContent} from 'common/utils';
import _ from 'lodash';

export class ManagePanelReviewEntities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
      pageNum: 0,
      error: false,
      loading: false,
      numEntities: 0,
      totalPages: 0,
    };
  }

  getEntities = () => {
    const {token, sessionId} = this.props;
    this.setState({
      loading: true,
    });
    return REST.panelReviewV2
      .getEntitiesBySession(token, sessionId, this.state.pageNum)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (_.size(_.get(res, 'content')) === 0) {
          this.setState({
            error: true,
            loading: false,
          });
        } else {
          this.setState({
            entities: [...res.content],
            error: false,
            loading: false,
            numEntities: res.totalElements,
            totalPages: res.totalPages,
          });
        }
      })
      .catch((err) => {
        this.setState({
          error: true,
          loading: false,
        });
        console.log('err');
      });
  };

  handlePageChange = async (e, {activePage}) => {
    await this.setState({pageNum: activePage - 1});
    this.getEntities();
  };

  componentDidMount() {
    this.getEntities();
  }

  mapStatus(entityStatus) {
    return _.get(PANEL_STATUS_CHANGE_DISPLAY, entityStatus);
  }

  renderTable(entities) {
    const {sessionId, linkTemplate} = this.props;
    const groupMap = new Map();
    const groups = _.filter(entities, 'group.name');
    _.forEach(groups, (g) => {
      groupMap.set(g.group.groupId, g.group.name);
    });
    return _.map(entities, (entity) => {
      let link = compileContent(linkTemplate, {
        sessionId: sessionId,
        entityId: entity.sessionEntityId.entityId,
      });
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell>{_.get(entity, 'organizationName')}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            <Link to={link}>
              {_.get(
                entity,
                'entityDisplay',
                _.get(entity, 'subGrantId', _.get(entity, 'grantId'))
              )}
            </Link>
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{_.get(entity, 'category')}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{_.get(entity, 'rank')}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {this.mapStatus(_.get(entity, 'status'))}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {groupMap.has(_.get(entity, 'groupId'))
              ? groupMap.get(_.get(entity, 'groupId'))
              : ''}
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    });
  }

  render() {
    const {aliases} = this.props;
    const {entities, error, pageNum, totalPages, loading} = this.state;
    const org = _.get(_.find(aliases, {value: 'organization'}), 'label');
    const id = _.get(_.find(aliases, {value: 'id'}), 'label');
    const category = _.get(_.find(aliases, {value: 'category'}), 'label');
    const entityType = _.get(
      _.find(aliases, {value: 'entityType'}),
      'label',
      'application'
    );
    if (loading)
      return (
        <Loader inline="centered" active>
          Loading...
        </Loader>
      );
    return (
      <React.Fragment>
        {error ? (
          <p>No data available</p>
        ) : (
          <React.Fragment>
            <FemaGoTable summary={`Manage ${entityType} data table`}>
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>{org}</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>{id}</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>{category}</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Rank</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Group name</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>{this.renderTable(entities)}</FemaGoTable.Body>
            </FemaGoTable>
            <Pagination
              activePage={pageNum + 1}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
              boundaryRange={1}
              ellipsisItem={null}
              totalPages={totalPages}
              onPageChange={this.handlePageChange}
            ></Pagination>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default connectWithCore(ManagePanelReviewEntities);
